import Vue from "vue";
import moment from "moment";

Vue.filter("date", (value) => moment(value).format("DD/MM/YYYY"));
Vue.filter("dateFormat", (value,format) => moment(value).format(format));
Vue.filter("showEffort", (value) => {
   return value<8 ? value : Math.round(value/8*10)/10;
});
